module.exports = __webpack_public_path__ + "static/media/cart-icon.4916ef70.svg";